var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1486 6.48093L18.6671 4.96236C19.5058 4.12367 20.8656 4.12367 21.7043 4.96236C22.543 5.80104 22.543 7.16082 21.7043 7.9995L20.1857 9.51808M17.1486 6.48093L8.22858 15.401C7.09617 16.5334 6.52995 17.0996 6.1444 17.7895C5.75884 18.4795 5.37093 20.1087 5 21.6667C6.55793 21.2957 8.18716 20.9078 8.87713 20.5222C9.56711 20.1367 10.1333 19.5705 11.2657 18.4381L20.1857 9.51808M17.1486 6.48093L20.1857 9.51808",
    stroke: "#9983FC",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5781 21.6667H19.0781",
    stroke: "#9983FC",
    strokeWidth: 1.625,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilEdit);
export default __webpack_public_path__ + "static/media/pencil-edit.cd6a0267f526f8d919d1393ca8e2c61d.svg";
export { ForwardRef as ReactComponent };